/*
 * Keep Shopify product option selects on the placeholder until the customer
 * explicitly chooses every option.
 *
 * Empire's built-in VariantHelper resolves partial/blank selections to the
 * closest variant. This file runs after empire.js and restores the placeholder
 * for any option the customer has not explicitly chosen.
 */
(function () {
  var OPTION_SELECT_SELECTOR = '[data-product-options-container] select[data-product-option]';
  var PRODUCT_FORM_SELECTOR = 'form[data-product-form]';
  var touchedSelects = new WeakSet();
  var initializedForms = new WeakSet();

  function getForm(element) {
    return element && element.closest(PRODUCT_FORM_SELECTOR);
  }

  function getOptionSelects(form) {
    if (!form) return [];

    return Array.prototype.slice.call(form.querySelectorAll(OPTION_SELECT_SELECTOR));
  }

  function getResettableSelects(form) {
    return getOptionSelects(form).filter(function (select) {
      return !!select.querySelector('option[value=""]');
    });
  }

  function getVariantSelect(form) {
    return form && form.querySelector('select[name="id"][data-variants]');
  }

  function getAtcButton(form) {
    return form && form.querySelector('[data-product-atc]');
  }

  function getSkuElement() {
    return document && document.querySelector('.product-sku');
  }

  function isComplete(form) {
    return getOptionSelects(form).every(function (select) {
      return select.value !== '';
    });
  }

  function hasTouchedSelect(form) {
    return getOptionSelects(form).some(function (select) {
      return touchedSelects.has(select);
    });
  }

  function selectPlaceholder(select) {
    var placeholder = select.querySelector('option[value=""]');

    if (!placeholder) return;

    placeholder.disabled = false;
    placeholder.selected = true;
    select.value = '';

    if (select.value !== '') {
      select.selectedIndex = placeholder.index;
    }
  }

  function updateFormState(form) {
    var complete = isComplete(form);
    var variantSelect = getVariantSelect(form);
    var atcButton = getAtcButton(form);
    var skuElement = getSkuElement();
    var priceLabel = document.querySelector('.price--label');
  
    if (variantSelect && !complete) {
      variantSelect.value = '';
      variantSelect.selectedIndex = -1;
    }

    if (atcButton) {
      atcButton.disabled = !complete;
      atcButton.classList.toggle('disabled', !complete);
      if (skuElement) {
        if (!complete) {
          skuElement.style.visibility = 'hidden';
        } else {
          skuElement.style.visibility = 'visible';
          if (priceLabel) {
            priceLabel.style.display = 'none';  
          }
        }
      }
    }
  }

  function resetUnchosenSelects(form, forceAll) {
    getResettableSelects(form).forEach(function (select) {
      if (forceAll || !touchedSelects.has(select)) {
        selectPlaceholder(select);
      }
    });

    updateFormState(form);
  }

  function initForm(form) {
    if (!form || initializedForms.has(form) || getOptionSelects(form).length === 0) {
      return;
    }

    initializedForms.add(form);

    // Run after Empire's section/product initialization has had a chance to
    // auto-select the first/closest variant.
    [0, 100, 500, 1000, 1500].forEach(function (delay) {
      window.setTimeout(function () {
        if (!hasTouchedSelect(form)) {
          resetUnchosenSelects(form, true);
        }
      }, delay);
    });
  }

  function initForms(root) {
    root = root || document;

    if (root.matches && root.matches(PRODUCT_FORM_SELECTOR)) {
      initForm(root);
    }

    Array.prototype.forEach.call(root.querySelectorAll(PRODUCT_FORM_SELECTOR), initForm);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest && event.target.closest(OPTION_SELECT_SELECTOR);

    if (!select) {
      return;
    }

    var form = getForm(select);

    if (event.isTrusted !== false && select.value !== '') {
      touchedSelects.add(select);
    }

    // Let Empire's VariantHelper run first, then restore any untouched dropdowns
    // back to the placeholder so auto-selection does not count as a user choice.
    window.setTimeout(function () {
      resetUnchosenSelects(form, false);
    }, 0);
  }, true);

  // Empire's ajax add-to-cart prevents native required validation, so block the
  // submit during the capture phase before Empire's submit handler runs.
  document.addEventListener('submit', function (event) {
    var form = event.target.closest && event.target.closest(PRODUCT_FORM_SELECTOR);

    if (!form || getOptionSelects(form).length === 0 || isComplete(form)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    updateFormState(form);

    var firstBlankSelect = getOptionSelects(form).filter(function (select) {
      return select.value === '';
    })[0];

    if (firstBlankSelect) {
      firstBlankSelect.focus();

      if (firstBlankSelect.reportValidity) {
        firstBlankSelect.reportValidity();
      }
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initForms(document);
    });
  } else {
    initForms(document);
  }

  // Handles dynamically inserted product forms, such as quickshop/modal forms.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          if (node.nodeType === 1) {
            initForms(node);
          }
        });
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
}());
